export default "__VITE_ASSET__DgDOsj7W__"